import {CartSkuOption} from '../types';

/**
 * Returns whichever among those skus given that is the first to denote itself as the default.
 *
 * If no sku claims to be the default, then the sku with the cheapest retail
 * price is assumed to be the default.
 */
const getDefaultSkuFromSkuArray = (skus: CartSkuOption[]) =>
    skus.find((sku) => sku.isDefault) ||
    skus.slice().sort((a, b) => a.retailPrice - b.retailPrice)[0];

export default getDefaultSkuFromSkuArray;
